"use strict";
// Import dinâmico = async boundary do Module Federation (permite eager: false).
import('./bootstrap');
